export enum PremiumTier {
	TelegramMonthly = 'telegram_monthly',
	TelegramQuarterly = 'telegram_quarterly'
}

export interface PremiumLimitsDto {
	maxCustomCategories: number;
	maxConcurrentSyncJobs: number;
}

export interface PremiumStatusDto {
	isPremium: boolean;
	tier?: PremiumTier;
	expiresAt?: string;
	limits: PremiumLimitsDto;
}

export interface UserArticleViewTrackRecord {
	lastArticleViewDate: string; // YYYY-MM-DD
	articleViewDayCount: number;
}

export interface CreateTelegramInvoiceRequest {
	tier: PremiumTier;
}

export interface CreateTelegramInvoiceResponse {
	invoiceSlug: string;
	payload: string;
	amount: number;
	currency: string;
	expiresAt: string;
	stars?: number;
}

